module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w98"
  }, [_c('div', {
    staticClass: "crumb"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": "/Help"
    }
  }, [_vm._v("帮助")]), _vm._v("  > ")], 1), _vm._v(" "), _c('span', [_vm._v("典型病例库")])]), _vm._v(" "), _c('help-Menu'), _vm._v(" "), _c('div', {
    staticClass: "rightContent"
  }, [_c('div', {
    staticClass: "conten"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v("此模块归属于“资料中心”，用户可以在此新增编辑自己的病例，并存放在公共分类中或者个人分类中。\n                 公共分类中的病例可供科室内部医生查看，个人分类中的病例只可自己查看修改。")]), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('el-collapse-item', [_c('template', {
    slot: "title"
  }, [_vm._v("\n              典型病例库\n            ")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("分类列表")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("分类列表处分为公共分类和个人分类tab页，支持列表的切换")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text"
  }, [_vm._v("公共分类：支持模糊查询，用户可在查询框中输入关键字，点击"), _c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/68.png")
    }
  }), _vm._v("，列表返回对应的查询结果。\n              公共分类共包括四个分类，分别为自定义分类、按诊断分类、按部位分类、按科室分类，分类不支持修改。\n              ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../static/image/4.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("个人分类：同公共分类一致，支持模糊查询。个人分类支持自定义分类，可新增、删除个人分类。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("1)新增：点击"), _c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/69.png")
    }
  }), _vm._v("按钮，在文本框中输入分类名称，点击“确定”按钮即可新增成功。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("2)删除：选中一分类，点击“删除”按钮，即可删除此条个人分类。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("病例添加")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("用户点击【添加病例】，进入病例新增页面。在病例新增时，用户需完成“基本信息”、“选择影像”、“上传附件”以及病例分类的填充选择（选择影像、上传附件不是必填项），最后点击【确定】，最终完成整个病例的新增。")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("“病例名称”、“性别”、“病例分类”为必填项，“年龄”、“备注”以及“就诊信息”为选填项。其中病例分类不可同时勾选公共分类和个人分类。")]), _vm._v(" "), _c('p', {
    staticClass: "textlittle"
  }, [_vm._v("1)病例分类选择"), _c('strong', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("公开分类")]), _vm._v("下的分类：该病例为科室内公开可见。")]), _vm._v(" "), _c('p', {
    staticClass: "textlittle"
  }, [_vm._v("2)病例分类选择"), _c('strong', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("个人分类")]), _vm._v("下的分类：该病例仅为个人所见。")])])], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "关联影像"
    }
  }, [_c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("影像添加")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("用户点击右侧按钮【从本院影像选择】，弹出影像库（图-本院影像），在影像库中，勾选相关影像后，点击“确定”后，完成添加，如图-影像队列。")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/10.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "30%"
    }
  }, [_vm._v("图-本院影像")]), _vm._v(" "), _c('div', [_c('img', {
    attrs: {
      "src": require("../../../../static/image/11.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "30%"
    }
  }, [_vm._v("图-影像队列")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("影像删除")]), _vm._v(" "), _c('p', [_vm._v("用户点击影像列表的"), _c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/75.png")
    }
  }), _vm._v("，即可从队列中删除该影像记录。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("影像阅片")]), _vm._v(" "), _c('P', [_vm._v("用户点击影像列表的"), _c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/71.png")
    }
  }), _vm._v("，即可调用系统的阅片工具对该记录进行阅片。")])], 1), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "title": "添加附件"
    }
  }, [_c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("“文件类型”添加")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("用户点击左侧按钮【从我的电脑选择】，弹出文件选择框，选择指定文件后，点击“确定”后，完成添加（只支持单个文件的添加，并且文件大小小于30M，最多添加10个）。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("“文件类型”删除")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("用户点击文件图标右上角"), _c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/72.png")
    }
  }), _vm._v("，确认后，即可删除文件。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("“其他图片”添加")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("用户点击左侧按钮【从我的电脑选择】，弹出文件选择框，选择指定文件后，点击“确定”后，完成添加（只支持单个文件的添加，并且文件大小小于3M，最多添加10个）。")]), _vm._v(" "), _c('h1', {
    staticClass: "titleBar"
  }, [_vm._v("“其他图片”删除")]), _vm._v(" "), _c('P', {
    staticClass: "text"
  }, [_vm._v("用户点击文件图标右上角"), _c('img', {
    staticClass: "littleImg",
    attrs: {
      "src": require("../../../../static/image/73.png")
    }
  }), _vm._v("，确认后，即可删除文件。")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-169ec1a8","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/moudle/ImageHospital/TypicalBank.vue
// module id = 530
// module chunks = 1 2 3 4 5 6 7 8